export default async function retryOnNetworkError(callback, maxRetries = 1) {
  if (!maxRetries || maxRetries < 1) {
    throw new Error('Max retries should be positive value.')
  }

  let attempt = 0;
  while (attempt <= maxRetries) {
    try {
      return await callback()
    } catch (error) {
      attempt++;
      if (attempt > maxRetries || !error || error.code !== 'ERR_NETWORK') {
        throw error;
      }
    }
  }
}
